// src/hooks/useDidUpdateEffect.ts
import { useEffect, useRef } from "react";
function useDidUpdateEffect(effect, deps) {
  const effectRef = useRef();
  const didMountRef = useRef(false);
  effectRef.current = effect;
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return () => {
      };
    }
    return effectRef?.current?.();
  }, deps);
}

// src/hooks/useIsMounted.ts
import { useCallback, useEffect as useEffect2, useRef as useRef2 } from "react";
function useIsMounted() {
  const mountedRef = useRef2(false);
  useEffect2(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return useCallback(() => mountedRef.current, []);
}

// src/hooks/usePrevious.ts
import { useEffect as useEffect3, useRef as useRef3 } from "react";
function usePrevious(value) {
  const ref = useRef3();
  useEffect3(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
export {
  useDidUpdateEffect,
  useIsMounted,
  usePrevious
};
//# sourceMappingURL=index.js.map